const TOUR_STORAGE_PREFIX = "aq_esource_form_builder_tour_v1";

export function getEsourceFormBuilderTourStorageKey(staffId) {
  const id = String(staffId || "").trim();
  return id ? `${TOUR_STORAGE_PREFIX}_${id}` : TOUR_STORAGE_PREFIX;
}

export function hasCompletedEsourceFormBuilderTour(staffId) {
  try {
    return (
      localStorage.getItem(getEsourceFormBuilderTourStorageKey(staffId)) === "1"
    );
  } catch {
    return false;
  }
}

export function markEsourceFormBuilderTourCompleted(staffId) {
  try {
    localStorage.setItem(getEsourceFormBuilderTourStorageKey(staffId), "1");
  } catch {
    /* ignore quota errors */
  }
}
